var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91667 11.8332C1.59583 11.8332 1.32128 11.719 1.093 11.4908C0.864722 11.2625 0.750389 10.9877 0.75 10.6665V2.49984C0.75 2.17901 0.864333 1.90445 1.093 1.67617C1.32167 1.44789 1.59622 1.33356 1.91667 1.33317H2.5V0.749839C2.5 0.584561 2.556 0.446117 2.668 0.334506C2.78 0.222895 2.91844 0.166895 3.08333 0.166506C3.24822 0.166117 3.38686 0.222117 3.49925 0.334506C3.61164 0.446895 3.66744 0.585339 3.66667 0.749839V1.33317H8.33333V0.749839C8.33333 0.584561 8.38933 0.446117 8.50133 0.334506C8.61333 0.222895 8.75178 0.166895 8.91667 0.166506C9.08156 0.166117 9.22019 0.222117 9.33258 0.334506C9.44497 0.446895 9.50078 0.585339 9.5 0.749839V1.33317H10.0833C10.4042 1.33317 10.6789 1.44751 10.9076 1.67617C11.1362 1.90484 11.2504 2.17939 11.25 2.49984V10.6665C11.25 10.9873 11.1359 11.2621 10.9076 11.4908C10.6793 11.7194 10.4046 11.8336 10.0833 11.8332H1.91667ZM1.91667 10.6665H10.0833V4.83317H1.91667V10.6665ZM1.91667 3.66651H10.0833V2.49984H1.91667V3.66651Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.aa313fdc0d8cf9264c85f28f79c719e8.svg";
export { ForwardRef as ReactComponent };